import { render, staticRenderFns } from "./Pengaturanruangan.vue?vue&type=template&id=50b084bf"
import script from "./Pengaturanruangan.vue?vue&type=script&lang=js"
export * from "./Pengaturanruangan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports